import React from 'react'
import { Navigate } from 'react-router-dom'
import { HiShieldExclamation } from 'react-icons/hi'
import { useAuth } from '../contexts/AuthContext'

const SuperuserRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!user?.is_superuser) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-12 text-center max-w-md">
          <div className="mx-auto w-16 h-16 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center mb-4">
            <HiShieldExclamation className="h-8 w-8 text-red-600 dark:text-red-400" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Superuser access required
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            City administration is limited to superuser accounts.
          </p>
        </div>
      </div>
    )
  }

  return children
}

export default SuperuserRoute
